import OutputMixin from '@/mixin/render-output.js'
export default {
    data () {
        return {

            type: 'Chiller',
            paramsList: [
                {
                    title: '冷冻机规格1',
                    prop: 'Chiller_Type_1',
                    Brand: 'York',  // 厂商
                    Model: '0050010120',  // 型号
                    readonly: true,
                    list: [
                        {
                            title: '台数',
                            prop: 'Qunty',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '运行台数',
                            prop: 'Qunty_Operate',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'Plr',
                            prop: 'Plr',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '制冷量(kw)',
                            prop: 'Load',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'EEFT(℃)',
                            prop: 'EEFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'ELFT(℃)',
                            prop: 'ELFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'EFLOW(m3/h)',
                            fullWidth: true,
                            prop: 'EFLOW',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CEFT(℃)',
                            prop: 'CEFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CLFT(℃)',
                            prop: 'CLFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CFLOW(m3/h)',
                            prop: 'CFLOW,m3/h',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CFLOW(%)',
                            prop: 'CFLOW,%',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '功率(kw)',
                            prop: 'Pe',
                            type: 'input',
                            vModel: 'N/A',
                        },
                    ],
                },

                {
                    title: '冷冻机规格2',
                    prop: 'Chiller_Type_2',
                    Brand: 'York',  // 厂商
                    Model: '0050013785',  // 型号
                    list: [
                        {
                            title: '台数',
                            prop: 'Qunty',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '运行台数',
                            prop: 'Qunty_Operate',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'Plr',
                            prop: 'Plr',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '制冷量(kw)',
                            prop: 'Load',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'EEFT(℃)',
                            prop: 'EEFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'ELFT(℃)',
                            prop: 'ELFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'EFLOW(m3/h)',
                            fullWidth: true,
                            prop: 'EFLOW',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CEFT(℃)',
                            prop: 'CEFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CLFT(℃)',
                            prop: 'CLFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CFLOW(m3/h)',
                            prop: 'CFLOW,m3/h',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CFLOW(%)',
                            prop: 'CFLOW,%',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '功率(kw)',
                            prop: 'Pe',
                            type: 'input',
                            vModel: 'N/A',
                        },
                    ],
                },

                {
                    title: '冷冻机规格3',
                    prop: 'Chiller_Type_3',
                    Brand: 'None',  // 厂商
                    Model: '0000000000',  // 型号
                    list: [
                        {
                            title: '台数',
                            prop: 'Qunty',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '运行台数',
                            prop: 'Qunty_Operate',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'Plr',
                            prop: 'Plr',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '制冷量(kw)',
                            prop: 'Load',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'EEFT(℃)',
                            prop: 'EEFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'ELFT(℃)',
                            prop: 'ELFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'EFLOW(m3/h)',
                            fullWidth: true,
                            prop: 'EFLOW',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CEFT(℃)',
                            prop: 'CEFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CLFT(℃)',
                            prop: 'CLFT',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CFLOW(m3/h)',
                            prop: 'CFLOW,m3/h',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: 'CFLOW(%)',
                            prop: 'CFLOW,%',
                            type: 'input',
                            vModel: 'N/A',
                        },
                        {
                            title: '功率(kw)',
                            prop: 'Pe',
                            type: 'input',
                            vModel: 'N/A',
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: 'ByPassFlow(m³/h)',
                            prop: 'Bypass_Flow',
                            type: 'input',
                            vModel: 'N/A',
                        },
                    ]
                }
            ],
        }
    },
    mixins: [OutputMixin]
}